import { memo, useMemo } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useSelector } from 'react-redux';
import Banner from '../banner/Banner';
import SectionMenu from '../section-menu/SectionMenu';
import { getHCOMenuItems } from '../view/utils';
import classes from './HealthSystem.module.scss';

const HealthSystem = memo((props) => {
  const { roleId } = useSelector((state) => state?.Auth?.userClaimObject);
  const { selectedView, componentAccessList } = props;

  const sectionMenuItems = useMemo(
    () => getHCOMenuItems(selectedView, componentAccessList, roleId),
    [selectedView, componentAccessList, roleId]
  );

  const filteredMenuItems = sectionMenuItems
    .filter((section) => section.shouldRender)
    .map(({ shouldRender, ...rest }) => rest);

  return (
    <>
      <Fade>
        <Banner data={selectedView} />
      </Fade>
      <SectionMenu
        data={selectedView}
        role={roleId}
        menuItems={filteredMenuItems}
      />
      {filteredMenuItems.map((section, index) => {
        const isOdd = index % 2 === 0;
        return (
          <Fade
            key={section.key}
            className={classes['no-animation-fill']}>
            <div
              style={{ marginBottom: '1em' }}
              className={isOdd ? 'full-width-in-container light-grey' : ''}>
              {section.component}
            </div>
          </Fade>
        );
      })}
    </>
  );
});

export default HealthSystem;
